import { Table } from 'antd';
import { TChangedField } from '../constant';
import { SaveConfirmModalWrapper } from '../FixedAssetLedgerDetailStyled';
import { FIXED_ASSET_DETAIL_CONSTANT } from '../constant';

const { TITLE } = FIXED_ASSET_DETAIL_CONSTANT;

interface SaveConfirmDialogProps {
  open: boolean;
  loading: boolean;
  changedFields: TChangedField[];
  onCancel: () => void;
  onOk: () => void;
}

const columns = [
  { title: '項目名', dataIndex: 'label', key: 'label', width: '40%' },
  { title: '変更後の値', dataIndex: 'value', key: 'value' },
];

export function SaveConfirmDialog({
  open,
  loading,
  changedFields,
  onCancel,
  onOk,
}: SaveConfirmDialogProps) {
  const hasChanges = changedFields.length > 0;

  return (
    <SaveConfirmModalWrapper
      open={open}
      title={TITLE.SAVE_CONFIRM_TITLE}
      maskClosable={false}
      confirmLoading={loading}
      onCancel={onCancel}
      cancelText={TITLE.BTN_CANCEL}
      okText={TITLE.BTN_OK}
      okButtonProps={{ disabled: !hasChanges }}
      onOk={onOk}
      width={560}
    >
      <p className="save-confirm_message">{TITLE.SAVE_CONFIRM_MSG}</p>

      {hasChanges ? (
        <Table
          dataSource={changedFields.map((f, i) => ({ ...f, key: i }))}
          columns={columns}
          pagination={false}
          size="small"
          bordered
        />
      ) : (
        <p className="save-confirm_no-changes">{TITLE.NO_CHANGES}</p>
      )}
    </SaveConfirmModalWrapper>
  );
}
